import TaskRoutes from "./TaskRoutes";

export default TaskRoutes;
